import { useState } from "react";
import { Ruler } from "lucide-react";

const toCm = (v: string) => `${Math.round(parseFloat(v) * 2.54)} cm`;

/**
 * Width × depth × height at a glance, only for dims that already passed plausibility checks.
 * A rug or mat arrives as Width × Length (extractOverallDims): it has no height to show.
 */
export const DimsCard = ({ dims }: { dims: Record<string, string> }) => {
  const [cm, setCm] = useState(false);
  const axes = (["Width", "Length", "Depth", "Height"] as const).filter((a) => dims[a]);
  if (axes.length < 2) return null;
  return (
    <div className="flex items-center justify-between gap-3 rounded-2xl border border-border px-4 py-3 mb-4">
      <div className="flex items-center gap-3 min-w-0">
        <Ruler className="h-4 w-4 text-foreground/40 flex-shrink-0" aria-hidden="true" />
        <p className="text-[14px] text-foreground">
          {axes.map((a, i) => (
            <span key={a}>
              {i > 0 && <span className="text-muted-foreground"> × </span>}
              <span className="font-semibold">{cm ? toCm(dims[a]) : dims[a]}</span>
              <span className="text-[11px] text-muted-foreground"> {a[0]}</span>
            </span>
          ))}
        </p>
      </div>
      <button
        type="button"
        onClick={() => setCm((v) => !v)}
        className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground underline underline-offset-2 hover:text-foreground flex-shrink-0"
        aria-label={cm ? "Show dimensions in inches" : "Show dimensions in centimeters"}
      >
        {cm ? "in" : "cm"}
      </button>
    </div>
  );
};
